/**
 * @desc 查询首页横幅分页列表
 */
import {
  PageBannerEntity,
  BannerPageParam
} from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryBannerPageParameter = BannerPageParam

const method = 'GET'
const url = '/content/operation/banner/page'

export const queryBannerPageApi = (
  params?: QueryBannerPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageBannerEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryBannerPageApi.method = method
queryBannerPageApi.url = url
